<!-- unknown.component.html -->
<div class="d-flex flex-column justify-content-center align-items-center vh-100 text-center bg-light">
  <h1 class="display-1 fw-bold text-danger">404</h1>
  <h2 class="mb-3">Oops! Page not found.</h2>
  <p class="mb-4 text-muted">
    The page you're looking for doesn't exist or has been moved.
  </p>
  <a routerLink="/" class="btn btn-primary btn-lg">
    <i class="bi bi-house-door-fill me-2"></i> Go Home
  </a>
</div>
